import { Controller } from '@hotwired/stimulus'

export default class extends Controller<HTMLDivElement> {
  static targets = ['errors']

  declare readonly errorsTarget: HTMLUListElement

  connect(): void {
    const inputWrapper = this.element.previousElementSibling
    inputWrapper?.querySelectorAll('input, textarea').forEach(input => {
      input.addEventListener('change', this.element.remove.bind(this.element))
    })
  }

  close(e: MouseEvent): void {
    e.preventDefault()
    this.element.remove()
  }
}
